export interface IPurchaseOrder {
  id?: number;
  poNumber?: string;
  createdDate?: string;
}

export const defaultValue: Readonly<IPurchaseOrder> = {};
